module.exports = __webpack_public_path__ + "static/media/logo_jules_cafe_LARGE.7d85c256.png";